import { Box, Container, Stack } from "@bookingcom/bui-react";
import { CampaignImpactSection } from "../components/CampaignImpact";
import { OverallPerformance } from "../components/OverallPerformance";
import { PerformanceReportHeader } from "../components/PerformanceReportHeader";

export function MetricsComponent() {
  return (
    <Container>
      <Box
        mixin={{
          paddingBlockStart: 8,
          paddingBlockEnd: 8,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
        }}
      >
        <Stack gap={8}>
          <PerformanceReportHeader />

          <Stack gap={12}>
            <CampaignImpactSection />
            <OverallPerformance />
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
}
